<template lang="pug">
  .component-reservation-list.row.column
    .row
      .column.small-12.large-4
      select(v-model="selectReport")
        option(value="") Select Report
        option(v-for="(report, index) in reports" v-bind:value="report.toLowerCase()") {{ report }}

    .row( v-if = "selectReport!=''")
      .column.small-3.large-3
        label Select Range
        date-range-picker(@input="dateRangeSelected" :key = "componentKey")
      .column.small-2.large-2(v-for = "formField in formFields[selectReport]")
        label {{ stringReplacer(formField) }}
        input(type= "string" placeholder='' v-model="search[formField]" class="roundedBorder")
      .column.small-1.large-1
        label Delimiter
        input.text-center(type="text"  v-model ="search['delimiter']" )
      .column.small-1.large-1
        div(class='buttonContainer')
          a.fa.fa-3x.fa-file-excel-o(v-on:click="openCsv" title="download csv")
      .column.small-1.large-1
        div(class='buttonContainer')
          a.fa.fa-3x.fa-copy(v-on:click="copyURL" title="copy url to clipboard")
      .column(v-if="viewUrl")
        input(type="text" id="myInput" :value="url")

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import DateRangePicker from "../../components/structure/DateRangePicker";
import MaggieHelper from "../../maggieHelper";

export default {
  name: "Export",
  components: {
    DateRangePicker,
  },
  data() {
    return {

      reports: '',
      selectReport: '',
      search: {
        'delimiter': null
      },
      componentKey: 0,
      formFields: '',
      viewUrl: false,
      url: '',

    }

  },
  watch: {
    selectReport: function () {
      this.resetData()
    },
    search: function () {
    }
  },
  mounted() {
    this.loadFormFields()
  },
  methods: {

    dateRangeSelected(range) {
      this.search.from = range.start
      this.search.to = range.end
    },

    resetData() {
      this.search = {}
      this.componentKey += 1;
      this.viewUrl = false
    },

    loadFormFields() {
      KeplerBackofficeSdk.export.getTypes((data) => {
        this.formFields = data
        this.reports = Object.keys(data)
        let k = Object.keys(this.formFields)
        if (k.includes('coupons')) {
          this.formFields['coupons'][0] = 'common_cost_id'
        }
      })
    },
    stringReplacer(str) {
      return str.replace(/_/g, ' ')
    },
    getUrl() {
      let body = {}
      body = this.createBody('from', 'to')

      return KeplerBackofficeSdk.export.getCsv(this.selectReport, body)
    },
    copyURL() {
      this.viewUrl = true
      this.url = this.getUrl()

      setTimeout(() => {
        document.getElementById('myInput').select()
        document.execCommand("copy")
        MaggieHelper.notification('Url copied to Clipboard')

      }, 100)

    },
    openCsv() {
      this.url = this.getUrl()

      this.copyURL(this.url)
      window.open(this.url, '_blank')
    },
    createBody(fromField, toField) {
      const body = {
        start: this.search[fromField],
        end: this.search[toField],
        params: {}
      }
      if (this.search.delimiter) {
        this.search.delimiter = this.search.delimiter.trim()
      }

      Object.keys(this.search)
        .filter(k => !!this.search[k] && k != fromField && k != toField)
        .forEach(f => body.params[f] = this.search[f])
      return body
    }
  },
  computed: {},
}
</script>
<style lang="sass" rel="stylesheet/sass">
.buttonContainer
  padding: 20px 0 0 20px

  .toCapitalFirst
    text-transform: capitalize

.roundedBorder
  border: none
  border-radius: 4px
  height: 38px

</style>



// WEBPACK FOOTER //
// Export.vue?46e78361